import { FC, Suspense } from "react";
import { ErrorBoundary } from "common/components";

type GuestLayoutProps = {
  children: React.ReactElement;
};

const GuestLayout: FC<GuestLayoutProps> = ({ children }: GuestLayoutProps) => {
  return (
    <>
      <main className="app-guest-layout">
        <Suspense
          fallback={
            <>
              <div>Fallback</div>
            </>
          }
        >
          <ErrorBoundary>{children}</ErrorBoundary>
        </Suspense>
      </main>
    </>
  );
};

export default GuestLayout;
